import Link from "@casino/client/components/Link";
import { Button, cn, PlayIcon } from "@workspace/frontend-ui";

type Props = {
  href: string;
  label: string;
  className?: string;
  onClick?: () => void;
};

const HeroPlayButton: FC<Props> = ({ href, label, className, onClick }) => (
  <Button
    asChild
    className={cn("h-10 gap-1.5 px-4 font-semibold text-sm", className)}
  >
    <Link href={href} prefetch={false} onClick={onClick}>
      <PlayIcon className="size-5" />
      {label}
    </Link>
  </Button>
);

export default HeroPlayButton;
